// ─────────────────────────────────────────────
//  MiniQR — lightweight QR preview for marketing pages
// ─────────────────────────────────────────────

export default function MiniQR({ size = 80, color = "#1a1a2e" }) {
  const cells = Array.from({ length: 11 }, (_, r) =>
    Array.from({ length: 11 }, (_, c) => {
      const inFinder =
        (r < 3 && c < 3) || (r < 3 && c > 7) || (r > 7 && c < 3);
      if (inFinder) {
        const fr = r < 3 ? r : r - 8;
        const fc = c < 3 ? c : c - 8;
        if (r > 7 && c > 7) return false;
        return fr === 0 || fr === 2 || fc === 0 || fc === 2 || (fr === 1 && fc === 1);
      }
      return ((r * 17 + c * 13 + r * c) % 3) === 0;
    })
  );
  const cell = size / 11;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <rect width={size} height={size} fill="white" rx={4} />
      {cells.map((row, r) =>
        row.map((on, c) =>
          on ? (
            <rect
              key={`${r}-${c}`}
              x={c * cell + 0.5} y={r * cell + 0.5}
              width={cell - 0.5} height={cell - 0.5}
              fill={color} rx={cell * 0.2}
            />
          ) : null
        )
      )}
    </svg>
  );
}
